module.exports = "<div>\n  <table class=\"ring-table\" ng-transclude>\n  </table>\n</div>\n";